import React from "react";
import { getUserDetails } from "../constants/helpers/getUserDetails";

const mineData = [
  { mineId: "BG01", name: "Balaghat" },
  { mineId: "DB01", name: "Dongri Buzurg" },
  { mineId: "TD01", name: "Tirodi" },
  { mineId: "CH01", name: "Chikla" },
  { mineId: "BL01", name: "Beldongri" },
  { mineId: "SP01", name: "Sitapatore" },
  { mineId: "GM01", name: "Gumgaon" },
  { mineId: "UK01", name: "Ukwa" },
  { mineId: "KD01", name: "Kandri" },
  { mineId: "MS01", name: "Munsar" },
];

export default function SelectMine({ selectedMine, onChange, style }) {
  const user = getUserDetails();
  const userRoles = Array.isArray(user?.designation) ? user.designation.map(d => d.toLowerCase()) : (typeof user?.designation === "string" ? [user.designation.toLowerCase()] : []);
  const isSuperAdmin = userRoles.includes("superadmin");

  if (!isSuperAdmin) {
    return null;
  }

  return (
    <select value={selectedMine} onChange={onChange} className="premium-select-mine" style={style}>
      <option value="">Select Mine</option>
      {mineData.map((mine) => (
        <option key={mine.mineId} value={mine.mineId} style={{ color: "#333" }}>
          {mine.name}
        </option>
      ))}
    </select>
  );
}
